import { useLocale } from "@/context/LocaleContext";

const PARTNERS = [
  {
    name: "BuildStore",
    logo: "https://cdn.builder.io/api/v1/image/assets%2F1abb0f3b5e864cc1bc1463ed28f1bd4f%2Feb4b3319a60848859275abb30f6f6e07?format=webp&width=800",
  },
  {
    name: "Stripe",
    logo: "https://cdn.brandfetch.io/stripe.com/w/400/h/400/theme/dark/icon.jpeg?t=1734076923936",
  },
  {
    name: "Vercel",
    logo: "https://assets.vercel.com/image/upload/front/favicon/vercel/180x180.png",
  },
  {
    name: "Supabase",
    logo: "https://supabase.com/dashboard/_next/image?url=%2Fdashboard%2Fimg%2Fsupabase-logo.png&w=64&q=75",
  },
  {
    name: "Cloudflare",
    logo: "https://cdn.brandfetch.io/cloudflare.com/w/400/h/400/theme/dark/icon.jpeg?t=1734076923936",
  },
  {
    name: "Netlify",
    logo: "https://cdn.brandfetch.io/netlify.com/w/400/h/400/theme/dark/icon.jpeg?t=1734076923936",
  },
  {
    name: "Figma",
    logo: "https://cdn.brandfetch.io/figma.com/w/400/h/400/theme/dark/icon.jpeg?t=1734076923936",
  },
  {
    name: "PayPal",
    logo: "https://cdn.builder.io/api/v1/image/assets%2F1abb0f3b5e864cc1bc1463ed28f1bd4f%2Fc1f24ed3552f47c5a3e0227562387487?format=webp&width=800",
  },
  {
    name: "Google",
    logo: "https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png",
  },
  {
    name: "Contentful",
    logo: "https://cdn.brandfetch.io/contentful.com/w/400/h/400/theme/dark/icon.jpeg?t=1734076923936",
  },
  {
    name: "AWS",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Amazon_Web_Services_Logo.svg/250px-Amazon_Web_Services_Logo.svg.png",
  },
];

export default function PartnersBar() {
  const { t } = useLocale();

  const items = [...PARTNERS, ...PARTNERS];

  return (
    <section className="mt-12 border-t border-white/8 bg-white/[0.02]">
      <div className="container mx-auto py-6">
        <div className="flex flex-col gap-4">
          <div className="text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/60">
              {t("partners.title")}
            </p>
            <p className="mt-1 text-sm text-white/60 max-w-2xl mx-auto">
              {t("partners.subtitle")}
            </p>
          </div>
          <div className="relative mt-3 overflow-hidden partners-marquee-mask">
            <div className="partners-marquee-track">
              {items.map((partner, index) => (
                <div
                  key={`${partner.name}-${index}`}
                  className={`flex items-center justify-center rounded-lg border border-white/8 bg-white/[0.03] p-3 backdrop-blur flex-shrink-0 ${
                    partner.name === "BuildStore"
                      ? "w-[140px] h-[80px]"
                      : "w-[110px] h-[60px]"
                  }`}
                  title={partner.name}
                >
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="max-w-full max-h-full object-contain opacity-80 hover:opacity-100 transition-opacity"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = "none";
                      const parent = target.parentElement;
                      if (parent) {
                        parent.innerHTML = `<span class="text-xs text-white/70">${partner.name}</span>`;
                      }
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
